export const en = {
    "k_6645596d": "You do not have permission to access this project",
    "k_61b58e50": "Failed to obtain project information: {arg_0}",
    "k_f8df9269": "Initializing the AI project...",
    "k_e3b6ad74": "You do not have edit rights for this project",
    "k_c213ec27": "Failed to initialize AI project: {arg_0}",
    "k_e48ac5b3": "AI project was successfully initialized"
};
